import { useMemo, type CSSProperties, type ReactNode } from 'react';
import { tenantPalette } from './contrast';

/**
 * White-label (ADR D17): inside a client portal the tenant's primary color replaces pear-700. Button
 * fills, links and focus rings use a shade that carries white text at 4.5:1; sky and rust keep
 * their status meaning and are never themed.
 */
export function TenantTheme({ primaryColor, className, children }: { primaryColor: string | null | undefined; className?: string; children: ReactNode }) {
  const style = useMemo(() => {
    const p = tenantPalette(primaryColor);
    return {
      '--brand': p.brand,
      '--brand-fill': p.fill,
      '--brand-hover': p.hover,
      '--brand-tint': p.tint,
      '--focus': p.fill,
    } as CSSProperties;
  }, [primaryColor]);
  return (
    <div className={className} style={style} data-tenant-theme="">
      {children}
    </div>
  );
}
